import DesignRecipeImages from "../DesignRecipeImages"
const AllImages = () => {
  return <DesignRecipeImages forAllImages={true} />
}

export default AllImages
